import BaseComponent from "../baseComponent.js";
import styles from "./modal.scss";

export default class VersionCheckModal extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.$modal = $("#version-check-modal");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    $("#app-bar").css('z-index', '100');
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  reload() {
    document.location.href = "/";
  }

  render() {
    return (
      <div id="version-check-modal" className={[styles.modal, "modal"].join(' ')} style={{width: '450px'}}>
        <div className="modal-content">
          <h5>There is new version available!</h5>
        </div>
        <div className={styles.footer}>
          <button
            className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')}>Cancel
          </button>
          <button className={[styles.actionButton, "btn waves-effect"].join(' ')} onClick={this.reload}>Reload</button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/versionCheckModal.jsx